import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationFeature } from "@green0meter/api-client";

import { CardAction } from "@components/common";
import { CustomColors } from "@type/CustomPalette";

interface DefaultRecommendationProps {
  feature: ApplicationFeature;
}

const DefaultRecommendation: FC<DefaultRecommendationProps> = ({ feature }) => {
  const { t } = useTranslation();

  const RECOMMENDATION_MAP: Partial<
    Record<
      ApplicationFeature,
      {
        icon: CardAction["icon"];
        color: CustomColors;
        title: string;
        text: string;
        button: CardAction["button"];
      }
    >
  > = {
    [ApplicationFeature.CO2]: {
      icon: "computer",
      color: "teal",
      title: t("recommendations.co2.title"),
      text: t("recommendations.co2.description"),
      button: {
        text: t("common.start"),
        href: "/co2",
      },
    },
    [ApplicationFeature.CSRD]: {
      icon: "finances",
      color: "purple",
      title: t("recommendations.csrd.title"),
      text: t("recommendations.csrd.description"),
      button: {
        text: t("common.start"),
        href: "/csrd",
      },
    },
    [ApplicationFeature.PROCUREMENT_BUYER]: {
      icon: "data-gathering",
      color: "purple",
      title: t("recommendations.generic.title"),
      text: t("recommendations.generic.description"),
      button: {
        text: t("common.start"),
        href: "/buyers-hub",
      },
    },
  };

  const config = RECOMMENDATION_MAP[feature];

  if (!config) return null;

  return <CardAction {...config} />;
};

export default DefaultRecommendation;
